import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment, lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import StarRatings from 'react-star-ratings';
import MoreActions from './MoreActions';
import ProposalStatusPill from '../ProposalStatusPill';
import UserViewsTable from '../../UserViewsTable';
import ProposalResponse from '../../ProposalResponse';
import ProfileCompletion from '../ProfileCompletion';
import ProposalFeedbacks from '../../ProposalFeedbacks';
import AddProposalPastRoles from '../../AddProposalPastRoles';
import userMapIcon from '../../../../assets/images/icons/map-pin.png';
import cloraIcon from '../../../../assets/images/onboarding-state-active.svg';
import profileIcon from '../../../../assets/images/profile-user.png';
import experienceIcon from '../../../../assets/images/icons/experience.svg';
import clockIcon from '../../../../assets/images/icons/clock-yellow.svg';
import checkmarkImg from '../../../../assets/images/check-mark.svg';
import remarkStarsIcon from '../../../../assets/images/remark_stars.svg';
import Loading from '../Loading';
import { postRequest, putRequest } from '../../../requestUtils';
import './ProposalShow.scss';
var AcceptProposal = /*#__PURE__*/lazy(function () {
  return import('../../AcceptProposal');
});
var ConfirmSubmitProposal = /*#__PURE__*/lazy(function () {
  return import('../ConfirmSubmitProposal');
});
var ScheduleInterviewModal = /*#__PURE__*/lazy(function () {
  return import('../../ScheduleInterviewModal');
});
var SubmitToEmployer = /*#__PURE__*/lazy(function () {
  return import('../../SubmitToEmployer');
});
var AskQuestion = /*#__PURE__*/lazy(function () {
  return import('../../AskQuestion');
});
var ProposalQuestion = /*#__PURE__*/lazy(function () {
  return import('../ProposalQuestion');
});
var ProposalMessages = /*#__PURE__*/lazy(function () {
  return import('../../ProposalMessages/ProposalMessages');
});
var ConfirmModal = /*#__PURE__*/lazy(function () {
  return import('../../ConfirmModal');
});
var DeclineProposal = /*#__PURE__*/lazy(function () {
  return import('../../DeclineProposal');
});
var AddCoworkersModal = /*#__PURE__*/lazy(function () {
  return import('../../AddCoworkersModal');
});
var ShareResource = /*#__PURE__*/lazy(function () {
  return import('../../ShareResource');
});
var ProposalInterviews = /*#__PURE__*/lazy(function () {
  return import('../../ProposalInterviews');
});
var WaitlistedNotification = /*#__PURE__*/lazy(function () {
  return import('../WaitlistedNotification');
});
var Resume = /*#__PURE__*/lazy(function () {
  return import('../Resume');
});
var InterviewQuestions = /*#__PURE__*/lazy(function () {
  return import('../../InterviewQuestions');
});
var ProjectFitSummary = /*#__PURE__*/lazy(function () {
  return import('../ProjectFitSummary');
});
var WithdrawProposal = /*#__PURE__*/lazy(function () {
  return import('../WithdrawProposal');
});
var TransferApplication = /*#__PURE__*/lazy(function () {
  return import('../TransferApplication');
});
var tabs = function tabs() {
  var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var isCloraRep = arguments.length > 1 ? arguments[1] : undefined;
  var employer = arguments.length > 2 ? arguments[2] : undefined;
  var showInterviewTab = arguments.length > 3 ? arguments[3] : undefined;
  var showMessages = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var tabsArray = ['Proposal'];
  if (showMessages) tabsArray.push('Messages');
  if ((isCloraRep || employer) && showInterviewTab) tabsArray.push('Interview Questions');
  if (document) tabsArray.push('Resume');
  if (isCloraRep) tabsArray.push('PDF Preview');
  return tabsArray;
};
var tabSlug = function tabSlug(label) {
  switch (label) {
    case 'Messages':
      return 'messages';
    case 'Interview Questions':
      return 'interview-questions';
    case 'Resume':
      return 'resume';
    case 'PDF Preview':
      return 'pdf-preview';
    default:
      return 'proposal';
  }
};
var labelFromSlug = function labelFromSlug(slug) {
  switch ((slug || '').toLowerCase()) {
    case 'messages':
      return 'Messages';
    case 'interview-questions':
      return 'Interview Questions';
    case 'resume':
      return 'Resume';
    case 'pdf-preview':
      return 'PDF Preview';
    default:
      return 'Proposal';
  }
};
var renderCheckmark = function renderCheckmark(showImage) {
  return showImage ? /*#__PURE__*/React.createElement("img", {
    src: checkmarkImg,
    className: "checkmark-img",
    alt: "check mark"
  }) : null;
};
var imgTag = function imgTag(icon, altText) {
  return /*#__PURE__*/React.createElement("img", {
    className: "me-2",
    src: icon,
    alt: "".concat(altText)
  });
};
var handlePrint = function handlePrint() {
  var tempTitle = document.title;
  var project = $('#print-proposal').data('project');
  var consultant = $('#print-proposal').data('consultant');
  document.title = "Clora Proposal - ".concat(project, " - ").concat(consultant);
  window.print();
  document.title = tempTitle;
};
function ProposalResourceScript(_ref) {
  var resourceId = _ref.resourceId;
  return /*#__PURE__*/React.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: "window.proposalResourceId = '".concat(resourceId, "';")
    }
  });
}
var renderViewOpportunities = function renderViewOpportunities(btnClass) {
  return /*#__PURE__*/React.createElement("a", {
    href: "/opportunities",
    className: "btn ".concat(btnClass)
  }, "View Other Opportunities");
};
var renderResponse = function renderResponse(_ref2) {
  var checked = _ref2.checked,
    description = _ref2.description,
    notes = _ref2.notes,
    extraClasses = _ref2.extraClasses,
    extraSpanClasses = _ref2.extraSpanClasses;
  return /*#__PURE__*/React.createElement(ProposalResponse, {
    checked: checked,
    description: description,
    notes: notes,
    extraClasses: extraClasses,
    extraSpanClasses: extraSpanClasses
  });
};
var renderPastRoles = function renderPastRoles(pastRoles) {
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", null, "Relevant Past Roles", /*#__PURE__*/React.createElement("span", {
    type: "button",
    className: "ms-2",
    "data-toggle": "tooltip",
    "data-placement": "bottom",
    title: "Relevant past roles are roles the candidate has held in the past that are related to this project."
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-info-circle"
  }))), pastRoles.map(function (pr) {
    return /*#__PURE__*/React.createElement("div", {
      className: "body-text-2 fs-hide past-role mb-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "medium-weight"
    }, pr.title), /*#__PURE__*/React.createElement("div", null, pr.role), /*#__PURE__*/React.createElement("div", null, pr.company_name), /*#__PURE__*/React.createElement("div", {
      className: "mute fs-hide"
    }, pr.experience));
  }));
};
var renderAdvisorRemark = function renderAdvisorRemark(advisorRemark) {
  return /*#__PURE__*/React.createElement("div", {
    className: "clora-advisor-remark"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    className: "mt-0 mb-0"
  }, "Clora Remark"), imgTag(remarkStarsIcon, 'Stars')), /*#__PURE__*/React.createElement("div", null, advisorRemark));
};
var renderExpertiseTag = function renderExpertiseTag(title, expertiseTag) {
  var extraClasses = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 ".concat(extraClasses)
  }, /*#__PURE__*/React.createElement("h2", {
    className: "hearder-teal-green"
  }, title), expertiseTag.tags.map(function (ta) {
    return /*#__PURE__*/React.createElement(ProposalResponse, {
      checked: ta.checked,
      description: ta.description
    });
  }), expertiseTag.comments && /*#__PURE__*/React.createElement(ProposalResponse, {
    description: expertiseTag.comments.description,
    notes: expertiseTag.comments.notes
  }));
};
var ProposalShow = /*#__PURE__*/function (_Component) {
  function ProposalShow(props) {
    var _this;
    _classCallCheck(this, ProposalShow);
    _this = _callSuper(this, ProposalShow, [props]);
    var proposalDetails = props.proposalDetails;
    var document = proposalDetails.document,
      clora_rep = proposalDetails.clora_rep,
      employer = proposalDetails.employer,
      show_interview_tab = proposalDetails.show_interview_tab;
    var searchParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
    var urlTabSlug = searchParams ? searchParams.get('tab') : null;
    var initialTab = labelFromSlug(urlTabSlug);
    if (initialTab === 'Messages' && !proposalDetails.show_messages) initialTab = 'Proposal';
    _this.state = {
      selectedTab: initialTab || 'Proposal',
      document: proposalDetails.document,
      originalDocument: proposalDetails.originalDocument,
      headerTabs: tabs(document, clora_rep, employer, show_interview_tab, proposalDetails.show_messages),
      proposalDetails: proposalDetails,
      project: null,
      isSticky: false,
      showAddCoworkerModal: false,
      showAskQuestionModal: false,
      showProposalFeedbackModal: false,
      showWaitlistModal: false,
      errorMessage: ''
    };
    _this.clickTab = _this.clickTab.bind(_this);
    _this.renderTab = _this.renderTab.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.renderSendEmail = _this.renderSendEmail.bind(_this);
    _this.renderHireAgain = _this.renderHireAgain.bind(_this);
    _this.renderPrintToPDF = _this.renderPrintToPDF.bind(_this);
    _this.renderTabContent = _this.renderTabContent.bind(_this);
    _this.handleAfterSubmit = _this.handleAfterSubmit.bind(_this);
    _this.renderConfirmModal = _this.renderConfirmModal.bind(_this);
    _this.renderMoreActions = _this.renderMoreActions.bind(_this);
    _this.renderAskQuestion = _this.renderAskQuestion.bind(_this);
    _this.renderSendContract = _this.renderSendContract.bind(_this);
    _this.renderEditProposal = _this.renderEditProposal.bind(_this);
    _this.renderNameAndStatus = _this.renderNameAndStatus.bind(_this);
    _this.renderHeaderActions = _this.renderHeaderActions.bind(_this);
    _this.renderLeaveFeedback = _this.renderLeaveFeedback.bind(_this);
    _this.renderShareResource = _this.renderShareResource.bind(_this);
    _this.renderAcceptProposal = _this.renderAcceptProposal.bind(_this);
    _this.renderDeleteProposal = _this.renderDeleteProposal.bind(_this);
    _this.renderSubmitProposal = _this.renderSubmitProposal.bind(_this);
    _this.handleShowAskQuestion = _this.handleShowAskQuestion.bind(_this);
    _this.renderDeclineProposal = _this.renderDeclineProposal.bind(_this);
    _this.renderleftBodyContent = _this.renderleftBodyContent.bind(_this);
    _this.renderWathdrawProposal = _this.renderWathdrawProposal.bind(_this);
    _this.handleWaitlistProposal = _this.handleWaitlistProposal.bind(_this);
    _this.renderWaitlistProposal = _this.renderWaitlistProposal.bind(_this);
    _this.renderSubmitToEmployer = _this.renderSubmitToEmployer.bind(_this);
    _this.renderForceStatusChange = _this.renderForceStatusChange.bind(_this);
    _this.handleShowCoworkerModal = _this.handleShowCoworkerModal.bind(_this);
    _this.renderShareWithColleague = _this.renderShareWithColleague.bind(_this);
    _this.handleOptionClick = debounce(_this.handleOptionClick.bind(_this), 300);
    _this.renderTransferApplication = _this.renderTransferApplication.bind(_this);
    _this.handleToggleWaitlistModal = _this.handleToggleWaitlistModal.bind(_this);
    _this.handleShowProposalFeedback = _this.handleShowProposalFeedback.bind(_this);
    _this.renderScheduleInterviewModal = _this.renderScheduleInterviewModal.bind(_this);
    _this.handleClearErrorMessage = _this.handleClearErrorMessage.bind(_this);
    return _this;
  }
  _inherits(ProposalShow, _Component);
  return _createClass(ProposalShow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      try {
        if (typeof window !== 'undefined') {
          window.showProposalMessages = !!this.state.proposalDetails.show_messages;
        }
      } catch (e) {/* noop */}
      // Ensure inline PDF preview is visible on initial load if URL tab=pdf-preview
      try {
        var prev = document.getElementById('pdf-preview-inline');
        if (prev && this.state.selectedTab === 'PDF Preview') {
          prev.classList.remove('d-none');
        }
      } catch (e) {/* noop */}
      window.addEventListener('scroll', this.handleScroll);
      // Sync selected tab with URL (back/forward navigation)
      window.addEventListener('popstate', function () {
        var params = new URLSearchParams(window.location.search);
        var label = labelFromSlug(params.get('tab'));
        var proposalDetails = _this2.state.proposalDetails;
        var showMessages = proposalDetails.show_messages;
        var nextLabel = label === 'Messages' && !showMessages ? 'Proposal' : label;
        _this2.setState({
          selectedTab: nextLabel
        });
        try {
          var _prev = document.getElementById('pdf-preview-inline');
          if (_prev) {
            if (nextLabel === 'PDF Preview') _prev.classList.remove('d-none');else _prev.classList.add('d-none');
          }
        } catch (e) {/* noop */}
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: "getButtonActions",
    value: function getButtonActions() {
      var _this3 = this;
      var createInterviewUrl = this.props.createInterviewUrl;
      var proposalDetails = this.state.proposalDetails;
      var actionButtons = proposalDetails.action_buttons,
        employer = proposalDetails.employer;
      var actions = {
        'Submit Proposal': function Submit_Proposal(buttonStyles) {
          return _this3.renderSubmitProposal(buttonStyles.substring(4));
        },
        Decline: function Decline(buttonStyles) {
          return _this3.renderDeclineProposal('decline', 'Decline', 'button', buttonStyles);
        },
        Withdraw: function Withdraw(buttonStyles) {
          return _this3.renderWathdrawProposal('button', buttonStyles);
        },
        'Request Edit': function Request_Edit(buttonStyles) {
          return _this3.renderAskQuestion(buttonStyles);
        },
        'Proposal Question': function Proposal_Question(buttonStyles) {
          return _this3.renderProposalQuestion('button', buttonStyles);
        },
        'Leave Feedback': function Leave_Feedback(buttonStyles) {
          return _this3.renderLeaveFeedback('Edit Reply', false, buttonStyles);
        },
        'Submit to Employer': function Submit_to_Employer(buttonStyles) {
          return _this3.renderSubmitToEmployer('button', buttonStyles.substring(4));
        },
        'Schedule Another Interview': function Schedule_Another_Interview(buttonStyles) {
          return _this3.renderScheduleInterviewModal("".concat(employer ? 'Request' : 'Schedule ', " Another Interview"), 'button', buttonStyles);
        },
        Waitlist: function Waitlist(buttonStyles) {
          return _this3.renderWaitlistProposal('button', buttonStyles);
        },
        'Schedule Interview': function Schedule_Interview(buttonStyles) {
          return _this3.renderConfirmModal('interview', 'Schedule Interview', createInterviewUrl, 'button', buttonStyles);
        },
        'Request Interview': function Request_Interview(buttonStyles) {
          return _this3.renderScheduleInterviewModal('Request Interview', 'button', buttonStyles);
        },
        'Share with a Colleague': function Share_with_a_Colleague(buttonStyles) {
          return _this3.renderShareWithColleague('button', buttonStyles);
        },
        Hire: function Hire(buttonStyles) {
          return _this3.renderAcceptProposal('hire', "Hire ".concat(proposalDetails.consultant_first_name), 'button', buttonStyles);
        },
        'Hire Again': function Hire_Again(buttonStyles) {
          return _this3.renderHireAgain(buttonStyles);
        },
        'Send Contract': function Send_Contract(buttonStyles) {
          return _this3.renderSendContract(buttonStyles);
        },
        'Send Email to Consultant': function Send_Email_to_Consultant(buttonStyles) {
          return _this3.renderSendEmail(buttonStyles);
        },
        'View Other Opportunities': function View_Other_Opportunities(buttonStyles) {
          return renderViewOpportunities(buttonStyles);
        },
        'Complete Proposal': function Complete_Proposal(buttonStyles) {
          return _this3.renderEditProposal('Complete Proposal', buttonStyles);
        },
        Edit: function Edit(buttonStyles) {
          return _this3.renderEditProposal('Edit', buttonStyles);
        },
        'More Actions': function More_Actions(buttonStyles) {
          return _this3.renderMoreActions(buttonStyles);
        }
      };
      var skipButtons = ['Decline', 'Share with a Colleague', 'View Other Opportunities'];
      var linkButton = ['Ask Question', 'Leave Feedback', 'Proposal Question', 'Withdraw'];
      var firstButtonSet = false;
      var buttonActions = actionButtons.map(function (action) {
        var _actions$action2;
        if (action === 'More Actions') {
          var _actions$action;
          return (_actions$action = actions[action]) === null || _actions$action === void 0 ? void 0 : _actions$action.call(actions);
        }
        var buttonStyles = 'btn--border-darkest';
        if (linkButton.includes(action)) {
          buttonStyles = 'btn--link-blue';
        } else if (!firstButtonSet && !skipButtons.includes(action)) {
          buttonStyles = 'btn--green-darkest';
          firstButtonSet = true;
        }
        return (_actions$action2 = actions[action]) === null || _actions$action2 === void 0 ? void 0 : _actions$action2.call(actions, buttonStyles);
      }).filter(Boolean);
      return buttonActions;
    }
  }, {
    key: "getDropdownList",
    value: function getDropdownList() {
      var _this$props = this.props,
        createInterviewUrl = _this$props.createInterviewUrl,
        consultantDetails = _this$props.consultantDetails;
      var proposalDetails = this.state.proposalDetails;
      var moreActions = proposalDetails.more_actions,
        employer = proposalDetails.employer;
      var actions = {
        Edit: this.renderEditProposal('Edit'),
        Decline: this.renderDeclineProposal('decline', 'Decline'),
        'Ask Question': this.renderAskQuestion('link'),
        'Send To Employer': this.renderSubmitToEmployer(),
        'Schedule Another Interview': this.renderScheduleInterviewModal("".concat(employer ? 'Request' : 'Schedule ', " Another Interview")),
        'Schedule Interview': this.renderConfirmModal('interview', 'Schedule Interview', createInterviewUrl),
        'Share Proposal': this.renderShareResource(),
        'Share with a Colleague': this.renderShareWithColleague('link'),
        Hire: this.renderAcceptProposal('hire', "Hire ".concat(consultantDetails.first_name)),
        Withdraw: this.renderWathdrawProposal(),
        'Provide feedback': this.renderLeaveFeedback('Provide feedback', true, 'link'),
        'Send Contract': this.renderSendContract(),
        'Send Email to Consultant': this.renderSendEmail(),
        'Move to Another Project': this.renderTransferApplication(),
        'Status Tracking': this.renderStatusTracking(),
        'Force Status Change': this.renderForceStatusChange(),
        'Feedback History': this.renderFeedbackHistory(),
        'Print to PDF': this.renderPrintToPDF(),
        Waitlist: this.renderWaitlistProposal('link'),
        'Proposal Question': this.renderProposalQuestion('link'),
        Delete: this.renderDeleteProposal()
      };
      var dropdownList = moreActions.filter(function (action) {
        return actions[action];
      }).map(function (action) {
        return actions[action];
      });
      return dropdownList;
    }
  }, {
    key: "clickTab",
    value: function clickTab(tabText) {
      // Toggle server-rendered PDF preview container without iframe
      try {
        var prev = document.getElementById('pdf-preview-inline');
        if (prev) {
          if (tabText === 'PDF Preview') {
            prev.classList.remove('d-none');
          } else {
            prev.classList.add('d-none');
          }
        }
      } catch (e) {/* noop */}
      this.setState({
        selectedTab: tabText
      });
      if (typeof window !== 'undefined') {
        var url = new URL(window.location.href);
        var slug = tabSlug(tabText);
        if (slug === 'proposal') {
          url.searchParams["delete"]('tab');
        } else {
          url.searchParams.set('tab', slug);
        }
        window.history.replaceState({}, '', url.toString());
      }
    }
  }, {
    key: "handleAfterSubmit",
    value: function handleAfterSubmit() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (Object.keys(data).length !== 0) {
        this.setState({
          proposalDetails: data
        });
      }
    }
  }, {
    key: "handleShowAskQuestion",
    value: function handleShowAskQuestion() {
      this.setState({
        showAskQuestionModal: true,
        showWaitlistModal: false
      });
    }
  }, {
    key: "handleClearErrorMessage",
    value: function handleClearErrorMessage() {
      var _this4 = this;
      setTimeout(function () {
        _this4.setState({
          errorMessage: ''
        });
      }, 6000);
    }
  }, {
    key: "handleShowProposalFeedback",
    value: function handleShowProposalFeedback() {
      this.setState({
        showProposalFeedbackModal: true
      });
    }
  }, {
    key: "handleToggleWaitlistModal",
    value: function handleToggleWaitlistModal() {
      this.setState(function (prevState) {
        return {
          showWaitlistModal: !prevState.showWaitlistModal,
          showAskQuestionModal: false,
          showAddCoworkerModal: false
        };
      });
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      this.setState({
        isSticky: window.scrollY > 200
      });
    }
  }, {
    key: "handleShowCoworkerModal",
    value: function handleShowCoworkerModal() {
      this.setState({
        showAddCoworkerModal: true,
        showWaitlistModal: false
      });
    }
  }, {
    key: "handleOptionClick",
    value: function handleOptionClick(value) {
      var _this5 = this;
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        proposalResourceId = _this$props2.proposalResourceId,
        currentUserEmail = _this$props2.currentUserEmail;
      postRequest("/proposals/".concat(proposalResourceId, "/proposal_feedbacks/"), {
        proposal_feedback: {
          consultant_fit: value,
          email: currentUserEmail
        }
      }, csrfToken).then(function (_ref3) {
        var data = _ref3.data;
        _this5.handleAfterSubmit(data.proposalDetails);
        _this5.handleShowProposalFeedback();
      });
    }
  }, {
    key: "handleWaitlistProposal",
    value: function handleWaitlistProposal() {
      var _this6 = this;
      var _this$props3 = this.props,
        csrfToken = _this$props3.csrfToken,
        proposalResourceId = _this$props3.proposalResourceId;
      putRequest("/proposals/".concat(proposalResourceId, "/waitlist"), {}, csrfToken).then(function (_ref4) {
        var data = _ref4.data;
        _this6.handleAfterSubmit(data);
        _this6.handleToggleWaitlistModal();
      })["catch"](function (e) {
        _this6.setState({
          errorMessage: (e === null || e === void 0 ? void 0 : e.base[0]) || (e === null || e === void 0 ? void 0 : e.status[0])
        });
        _this6.handleClearErrorMessage();
      });
    }
  }, {
    key: "renderAskQuestion",
    value: function renderAskQuestion() {
      var buttonStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var _this$props4 = this.props,
        cloraCreaeRroposalCommentsUrl = _this$props4.cloraCreaeRroposalCommentsUrl,
        csrfToken = _this$props4.csrfToken;
      var proposalDetails = this.state.proposalDetails;
      return /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement(Loading, null)
      }, /*#__PURE__*/React.createElement(AskQuestion, _extends({
        formUrl: cloraCreaeRroposalCommentsUrl,
        csrfToken: csrfToken,
        recipientName: proposalDetails.consultant_name
      }, buttonStyles && {
        buttonStyles: buttonStyles
      }, {
        triggerType: "link"
      })));
    }
  }, {
    key: "renderProposalQuestion",
    value: function renderProposalQuestion() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
      var buttonStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (type === 'link') {
        return /*#__PURE__*/React.createElement("a", {
          className: "link",
          role: "button",
          tabIndex: 0,
          onClick: this.handleShowAskQuestion
        }, "Ask a Question about this candidate");
      }
      return /*#__PURE__*/React.createElement("button", {
        className: "btn ".concat(buttonStyles),
        onClick: this.handleShowAskQuestion
      }, "Ask a Question");
    }
  }, {
    key: "renderAcceptProposal",
    value: function renderAcceptProposal(type, triggerCopy) {
      var triggerType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'link';
      var buttonStyles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var _this$props5 = this.props,
        csrfToken = _this$props5.csrfToken,
        acceptProposalUrl = _this$props5.acceptProposalUrl;
      var proposalDetails = this.state.proposalDetails;
      if (proposalDetails.can_be_accepted) {
        if (proposalDetails.employer) {
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: /*#__PURE__*/React.createElement(Loading, null)
          }, /*#__PURE__*/React.createElement(AcceptProposal, _extends({
            formUrl: acceptProposalUrl,
            csrfToken: csrfToken,
            consultantName: proposalDetails.consultant_first_name,
            triggerType: triggerType
          }, buttonStyles && {
            buttonStyles: buttonStyles.substring(4)
          })));
        }
        return this.renderConfirmModal(type, triggerCopy, acceptProposalUrl, triggerType, buttonStyles);
      }
      return null;
    }
  }, {
    key: "renderConfirmModal",
    value: function renderConfirmModal(type, triggerCopy, submitUrl) {
      var _this7 = this;
      var triggerType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'link';
      var buttonType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var _this$props6 = this.props,
        csrfToken = _this$props6.csrfToken,
        invitableRoles = _this$props6.invitableRoles,
        visibleFeedbackOptions = _this$props6.visibleFeedbackOptions,
        hiddenFeedbackOptions = _this$props6.hiddenFeedbackOptions,
        initialTeamMembers = _this$props6.initialTeamMembers,
        proposalResourceId = _this$props6.proposalResourceId,
        showNewProposalUX = _this$props6.showNewProposalUX,
        availableInterviewSlotUrl = _this$props6.availableInterviewSlotUrl;
      var proposalDetails = this.state.proposalDetails;
      var options = ['Decline'].includes(triggerCopy) ? visibleFeedbackOptions : hiddenFeedbackOptions;
      return /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement(Loading, null)
      }, /*#__PURE__*/React.createElement(ConfirmModal, _extends({
        submitUrl: submitUrl,
        proposalResourceId: proposalResourceId,
        csrfToken: csrfToken,
        consultantName: proposalDetails.consultant_name,
        possibleInterviewers: initialTeamMembers,
        invitableRoles: invitableRoles,
        modalTriggerType: triggerType,
        type: type,
        reasonOptions: options,
        modalTriggerCopy: triggerCopy,
        handleProposalAfterSubmit: function handleProposalAfterSubmit(data) {
          return _this7.handleAfterSubmit(data);
        }
      }, buttonType && {
        buttonType: buttonType
      }, {
        showNewProposalUX: showNewProposalUX,
        availableInterviewSlotUrl: availableInterviewSlotUrl
      })));
    }
  }, {
    key: "renderDeclineProposal",
    value: function renderDeclineProposal(type, triggerCopy) {
      var _this8 = this;
      var triggerType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'link';
      var buttonStyles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var _this$props7 = this.props,
        csrfToken = _this$props7.csrfToken,
        visibleFeedbackOptions = _this$props7.visibleFeedbackOptions,
        showNewProposalUX = _this$props7.showNewProposalUX;
      var proposalDetails = this.state.proposalDetails;
      if (proposalDetails.employer && proposalDetails.can_be_rejected || proposalDetails.rep && proposalDetails.can_be_declined_by_rep) {
        return /*#__PURE__*/React.createElement(Suspense, {
          fallback: /*#__PURE__*/React.createElement(Loading, null)
        }, /*#__PURE__*/React.createElement(DeclineProposal, _extends({
          formUrl: proposalDetails.reject_proposal_url,
          csrfToken: csrfToken,
          consultantName: proposalDetails.consultant_name,
          triggerType: triggerType,
          userType: proposalDetails.rep ? 'clora_rep' : 'employer',
          feedbackOptions: visibleFeedbackOptions,
          handleProposalAfterSubmit: function handleProposalAfterSubmit(data) {
            return _this8.handleAfterSubmit(data);
          }
        }, buttonStyles && {
          buttonStyles: buttonStyles.substring(4)
        }, {
          showNewProposalUX: showNewProposalUX
        })));
      }
      return null;
    }
  }, {
    key: "renderLeaveFeedback",
    value: function renderLeaveFeedback(buttonText, showLinkOnly, buttonStyles) {
      var _this9 = this;
      var proposalDetails = this.state.proposalDetails;
      var feedback = proposalDetails.feedback;
      return /*#__PURE__*/React.createElement(Fragment, null, showLinkOnly ? /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          _this9.setState({
            showProposalFeedbackModal: true
          });
        },
        className: buttonStyles
      }, buttonText) : /*#__PURE__*/React.createElement("div", {
        className: "leave-feedback"
      }, /*#__PURE__*/React.createElement("span", {
        className: "feedback-question"
      }, "Is", ' ', proposalDetails.consultant_first_name, ' ', "a good fit for this project?"), /*#__PURE__*/React.createElement("div", {
        className: "button-group"
      }, feedback.consultant_fit ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "status ".concat(feedback.consultant_fit)
      }, feedback.consultant_fit ? feedback.consultant_fit.toUpperCase() : ''), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.handleShowProposalFeedback,
        className: buttonStyles
      }, buttonText)) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "option-button ".concat(feedback.consultant_fit === 'yes' ? 'selected' : ''),
        onClick: function onClick() {
          return _this9.handleOptionClick('yes');
        }
      }, renderCheckmark(feedback.consultant_fit === 'yes'), "Yes"), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "option-button ".concat(feedback.consultant_fit === 'maybe' ? 'selected' : ''),
        onClick: function onClick() {
          return _this9.handleOptionClick('maybe');
        }
      }, renderCheckmark(feedback.consultant_fit === 'maybe'), "Maybe"), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "option-button ".concat(feedback.consultant_fit === 'no' ? 'selected' : ''),
        onClick: function onClick() {
          return _this9.handleOptionClick('no');
        }
      }, renderCheckmark(feedback.consultant_fit === 'no'), "No")))));
    }
  }, {
    key: "renderShareWithColleague",
    value: function renderShareWithColleague() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
      var buttonStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (type === 'link') {
        return /*#__PURE__*/React.createElement("a", {
          className: "link",
          role: "button",
          tabIndex: 0,
          onClick: this.handleShowCoworkerModal
        }, "Share with a Colleague");
      }
      return /*#__PURE__*/React.createElement("button", {
        className: "btn ".concat(buttonStyles),
        onClick: this.handleShowCoworkerModal
      }, "Share with a Colleague");
    }
  }, {
    key: "renderWaitlistProposal",
    value: function renderWaitlistProposal() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
      var buttonStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (type === 'link') {
        return /*#__PURE__*/React.createElement("a", {
          className: "link",
          role: "button",
          tabIndex: 0,
          onClick: this.handleWaitlistProposal
        }, "Waitlist this candidate");
      }
      return /*#__PURE__*/React.createElement("button", {
        className: "btn ".concat(buttonStyles),
        onClick: this.handleWaitlistProposal
      }, "Waitlist");
    }
  }, {
    key: "renderWathdrawProposal",
    value: function renderWathdrawProposal() {
      var _this10 = this;
      var triggerType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
      var buttonStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'link';
      var _this$props8 = this.props,
        csrfToken = _this$props8.csrfToken,
        consultantFeedbackOptions = _this$props8.consultantFeedbackOptions,
        showNewProposalUX = _this$props8.showNewProposalUX,
        withdrawUrl = _this$props8.withdrawUrl;
      var proposalDetails = this.state.proposalDetails;
      if (!proposalDetails.employer && proposalDetails.can_be_withdrawn) {
        return /*#__PURE__*/React.createElement(Suspense, {
          fallback: /*#__PURE__*/React.createElement(Loading, null)
        }, /*#__PURE__*/React.createElement(WithdrawProposal, _extends({
          formUrl: withdrawUrl,
          csrfToken: csrfToken,
          consultantName: proposalDetails.consultant_name,
          triggerType: triggerType,
          userType: proposalDetails.rep ? 'clora_rep' : 'consultant',
          feedbackOptions: consultantFeedbackOptions,
          handleProposalAfterSubmit: function handleProposalAfterSubmit(data) {
            return _this10.handleAfterSubmit(data);
          }
        }, buttonStyles && {
          buttonStyles: buttonStyles.substring(4)
        }, {
          showNewProposalUX: showNewProposalUX
        })));
      }
      return null;
    }
  }, {
    key: "renderTransferApplication",
    value: function renderTransferApplication() {
      var _this$props9 = this.props,
        projectsOptions = _this$props9.projectsOptions,
        projectResourceId = _this$props9.projectResourceId,
        csrfToken = _this$props9.csrfToken,
        proposalResourceId = _this$props9.proposalResourceId;
      var applicationProject = projectsOptions.find(function (project) {
        return project.value === projectResourceId;
      });
      var filteredProjects = projectsOptions.filter(function (project) {
        return project.value !== projectResourceId;
      });
      return /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement(Loading, null)
      }, /*#__PURE__*/React.createElement(TransferApplication, {
        triggerText: "Move to another project",
        triggerType: "link",
        idKey: "move-application-modal",
        selectOptions: filteredProjects,
        csrfToken: csrfToken,
        proposaltResourceId: proposalResourceId,
        applicationProject: applicationProject
      }));
    }
  }, {
    key: "renderSubmitToEmployer",
    value: function renderSubmitToEmployer() {
      var _this11 = this;
      var triggerTpy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
      var buttonStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var _this$props10 = this.props,
        csrfToken = _this$props10.csrfToken,
        showNewProposalUX = _this$props10.showNewProposalUX;
      var proposalDetails = this.state.proposalDetails;
      if (proposalDetails.can_be_submitted_to_employer && !proposalDetails.missing_required_response) {
        return /*#__PURE__*/React.createElement(Suspense, {
          fallback: /*#__PURE__*/React.createElement(Loading, null)
        }, /*#__PURE__*/React.createElement(SubmitToEmployer, _extends({
          formUrl: proposalDetails.submit_to_employer_url,
          csrfToken: csrfToken,
          triggerType: triggerTpy,
          resubmit: proposalDetails.can_be_resubmitted_to_employer,
          onBehalf: proposalDetails.can_be_submitted_to_clora,
          agreementSent: proposalDetails.agreement_sent,
          advisorRemark: proposalDetails.advisor_remark
        }, buttonStyles && {
          buttonStyles: buttonStyles
        }, {
          handleProposalAfterSubmit: function handleProposalAfterSubmit(data) {
            return _this11.handleAfterSubmit(data);
          },
          showNewProposalUX: showNewProposalUX
        })));
      }
      return null;
    }
  }, {
    key: "renderScheduleInterviewModal",
    value: function renderScheduleInterviewModal() {
      var triggerCopy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Schedule Another Interview';
      var triggerType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'link';
      var buttonStyles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var _this$props11 = this.props,
        createInterviewUrl = _this$props11.createInterviewUrl,
        proposalResourceId = _this$props11.proposalResourceId,
        csrfToken = _this$props11.csrfToken,
        initialTeamMembers = _this$props11.initialTeamMembers,
        invitableRoles = _this$props11.invitableRoles,
        availableInterviewSlotUrl = _this$props11.availableInterviewSlotUrl;
      var proposalDetails = this.state.proposalDetails;
      return /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement(Loading, null)
      }, /*#__PURE__*/React.createElement(ScheduleInterviewModal, _extends({
        createInterviewUrl: createInterviewUrl,
        proposalResourceId: proposalResourceId,
        csrfToken: csrfToken,
        consultantName: proposalDetails.consultant_name,
        possibleInterviewers: initialTeamMembers,
        invitableRoles: invitableRoles,
        modalTriggerType: triggerType,
        modalTriggerCopy: triggerCopy
      }, buttonStyles && {
        modalTriggerClassName: buttonStyles
      }, {
        showNPSOnSubmit: proposalDetails.should_be_shown_nps,
        availableInterviewSlotUrl: availableInterviewSlotUrl
      })));
    }
  }, {
    key: "renderDeleteProposal",
    value: function renderDeleteProposal() {
      var proposalResourceId = this.props.proposalResourceId;
      return /*#__PURE__*/React.createElement("a", {
        "data-turbo-confirm": "Are you sure you want to delete this proposal?",
        rel: "nofollow",
        "data-turbo-method": "delete",
        href: "/proposals/".concat(proposalResourceId),
        className: "link--text-red"
      }, "Delete");
    }
  }, {
    key: "renderStatusTracking",
    value: function renderStatusTracking() {
      var proposalResourceId = this.props.proposalResourceId;
      return /*#__PURE__*/React.createElement("a", {
        href: "/proposals/".concat(proposalResourceId, "/status_tracking"),
        className: "link"
      }, "Status Tracking");
    }
  }, {
    key: "renderForceStatusChange",
    value: function renderForceStatusChange() {
      var proposalResourceId = this.props.proposalResourceId;
      return /*#__PURE__*/React.createElement("a", {
        href: "/proposals/status_change?resource_id=".concat(proposalResourceId),
        className: "link"
      }, "Force Status Change");
    }
  }, {
    key: "renderSendContract",
    value: function renderSendContract() {
      var proposalResourceId = this.props.proposalResourceId;
      return /*#__PURE__*/React.createElement("a", {
        "data-turbo-confirm": "Are you sure you want to send contract to the consultant?",
        rel: "nofollow",
        "data-turbo-method": "post",
        href: "/proposals/".concat(proposalResourceId, "/send_contract"),
        className: "link"
      }, "Send Contract");
    }
  }, {
    key: "renderSendEmail",
    value: function renderSendEmail() {
      var proposalResourceId = this.props.proposalResourceId;
      return /*#__PURE__*/React.createElement("a", {
        "data-turbo-confirm": "Are you sure you want to send an email to the consultant?",
        rel: "nofollow",
        "data-turbo-method": "post",
        href: "/proposals/".concat(proposalResourceId, "/send_email")
      }, "Send Email to Consultant");
    }
  }, {
    key: "renderFeedbackHistory",
    value: function renderFeedbackHistory() {
      var proposalResourceId = this.props.proposalResourceId;
      return /*#__PURE__*/React.createElement("a", {
        href: "/proposals/".concat(proposalResourceId, "/feedback_history"),
        className: "link"
      }, "Feedback History");
    }
  }, {
    key: "renderShareResource",
    value: function renderShareResource() {
      var _this$props12 = this.props,
        csrfToken = _this$props12.csrfToken,
        sourceOptions = _this$props12.sourceOptions,
        showShareAction = _this$props12.showShareAction,
        recipientOptions = _this$props12.recipientOptions,
        proposalResourceId = _this$props12.proposalResourceId,
        generateShareableLink = _this$props12.generateShareableLink;
      if (showShareAction) {
        return /*#__PURE__*/React.createElement(Suspense, {
          fallback: /*#__PURE__*/React.createElement(Loading, null)
        }, /*#__PURE__*/React.createElement(ShareResource, {
          generateUrl: generateShareableLink,
          csrfToken: csrfToken,
          resourceId: proposalResourceId,
          triggerText: "Share Proposal",
          triggerType: "link",
          buttonStyles: "link",
          idKey: "share-proposal-modal",
          resourceType: "Proposal",
          sourceOptions: sourceOptions,
          recipientOptions: recipientOptions,
          forceModal: true,
          stopPropagation: true
        }));
      }
      return null;
    }
  }, {
    key: "renderPrintToPDF",
    value: function renderPrintToPDF() {
      var proposalResourceId = this.props.proposalResourceId;
      return /*#__PURE__*/React.createElement("a", {
        id: "print-proposal",
        className: "link",
        href: "/proposals/".concat(proposalResourceId, "/print.pdf"),
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Print to PDF");
    }
  }, {
    key: "renderNameAndStatus",
    value: function renderNameAndStatus() {
      var proposalDetails = this.state.proposalDetails;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h1", {
        className: "consultant-name"
      }, proposalDetails.consultant_name), /*#__PURE__*/React.createElement(ProposalStatusPill, {
        status: proposalDetails.status
      }));
    }
  }, {
    key: "renderMoreActions",
    value: function renderMoreActions() {
      return /*#__PURE__*/React.createElement(MoreActions, {
        listItems: this.getDropdownList()
      });
    }
  }, {
    key: "renderEditProposal",
    value: function renderEditProposal(buttonText) {
      var btnClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'link';
      var editProposalUrl = this.props.editProposalUrl;
      return /*#__PURE__*/React.createElement("a", {
        href: editProposalUrl,
        className: "".concat(btnClass === 'link' ? 'link' : "btn ".concat(btnClass))
      }, buttonText);
    }
  }, {
    key: "renderHireAgain",
    value: function renderHireAgain() {
      var btnClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
      var proposalDetails = this.props.proposalDetails;
      return /*#__PURE__*/React.createElement(Fragment, null, proposalDetails.show_hire_again && /*#__PURE__*/React.createElement("a", {
        href: proposalDetails.rehire_url,
        className: "".concat(btnClass === 'link' ? 'link' : "btn ".concat(btnClass))
      }, "Hire Again"));
    }
  }, {
    key: "renderHeaderActions",
    value: function renderHeaderActions() {
      var sticky = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var errorMessage = this.state.errorMessage;
      if (sticky) {
        return /*#__PURE__*/React.createElement("div", null, errorMessage && /*#__PURE__*/React.createElement("div", {
          className: "error-message"
        }, errorMessage), /*#__PURE__*/React.createElement("div", {
          className: "header-actions"
        }, this.getButtonActions().reverse().map(function (item) {
          return item;
        })));
      }
      return /*#__PURE__*/React.createElement(Fragment, null, errorMessage && /*#__PURE__*/React.createElement("div", {
        className: "error-message"
      }, errorMessage), /*#__PURE__*/React.createElement("div", {
        className: "header-actions"
      }, this.getButtonActions().map(function (item) {
        return item;
      })));
    }
  }, {
    key: "renderSubmitProposal",
    value: function renderSubmitProposal(buttonStyles) {
      var _this12 = this;
      var _this$props13 = this.props,
        editProposalUrl = _this$props13.editProposalUrl,
        animation = _this$props13.animation,
        csrfToken = _this$props13.csrfToken,
        updateUserSettingsUrl = _this$props13.updateUserSettingsUrl,
        disabledSubmitProposal = _this$props13.disabledSubmitProposal,
        referralProps = _this$props13.referralProps,
        showNewProposalUX = _this$props13.showNewProposalUX;
      var proposalDetails = this.state.proposalDetails;
      return /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement(Loading, null)
      }, /*#__PURE__*/React.createElement(ConfirmSubmitProposal, {
        editUrl: editProposalUrl,
        fullName: proposalDetails.consultant_full_name,
        updateUserSettingsUrl: updateUserSettingsUrl,
        formUrl: proposalDetails.submit_to_employer_url,
        submitToOpenMarketplace: proposalDetails.submit_directly_to_employer,
        csrfToken: csrfToken,
        animation: animation,
        disabled: disabledSubmitProposal,
        referralProps: referralProps,
        onSubmitCallback: function onSubmitCallback() {},
        buttonStyles: buttonStyles,
        handleProposalAfterSubmit: function handleProposalAfterSubmit(data) {
          return _this12.handleAfterSubmit(data);
        },
        showNewProposalUX: showNewProposalUX
      }));
    }
  }, {
    key: "renderTab",
    value: function renderTab(tabText, tabIndex) {
      var _this13 = this;
      var selectedTab = this.state.selectedTab;
      var isSelected = selectedTab === tabText;
      return /*#__PURE__*/React.createElement("a", {
        role: "button",
        className: "proposal-header__tab ".concat(isSelected ? 'tab--active' : ''),
        onClick: function onClick() {
          return _this13.clickTab(tabText);
        },
        key: tabText,
        tabIndex: tabIndex
      }, tabText);
    }
  }, {
    key: "renderleftBodyContent",
    value: function renderleftBodyContent() {
      var _this14 = this;
      var _this$props14 = this.props,
        proposal = _this$props14.proposal,
        proposalPastRolesUrl = _this$props14.proposalPastRolesUrl,
        csrfToken = _this$props14.csrfToken,
        selectedPastRolesIds = _this$props14.selectedPastRolesIds,
        pastRoles = _this$props14.pastRoles,
        selectedPastRoles = _this$props14.selectedPastRoles,
        proposalQuestionUrl = _this$props14.proposalQuestionUrl,
        completionPercentage = _this$props14.completionPercentage,
        userPath = _this$props14.userPath,
        initialTeamMembers = _this$props14.initialTeamMembers,
        invitableRoles = _this$props14.invitableRoles,
        consultantInterviewPath = _this$props14.consultantInterviewPath,
        canCancelInterview = _this$props14.canCancelInterview,
        canEditInterview = _this$props14.canEditInterview,
        repOrOwner = _this$props14.repOrOwner,
        showBackgroundCheck = _this$props14.showBackgroundCheck,
        availableInterviewSlotUrl = _this$props14.availableInterviewSlotUrl;
      var _this$state = this.state,
        proposalDetails = _this$state.proposalDetails,
        showAskQuestionModal = _this$state.showAskQuestionModal;
      return /*#__PURE__*/React.createElement("div", {
        className: "left-body-content"
      }, completionPercentage && completionPercentage < 100 && /*#__PURE__*/React.createElement("div", {
        className: "body-section"
      }, /*#__PURE__*/React.createElement(ProfileCompletion, {
        header: "Receive better project recommendations, rank higher, and increase your chances of being interviewed.",
        percentage: completionPercentage,
        userPath: userPath,
        location: "Proposal Show - ".concat(proposal.status)
      })), /*#__PURE__*/React.createElement("div", {
        className: "body-section"
      }, proposalDetails.hourly_rate && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", null, proposalDetails.hourly_rate), /*#__PURE__*/React.createElement("hr", null)), proposalDetails.tax_type && renderResponse(proposalDetails.tax_type), proposalDetails.work_in_office && renderResponse(proposalDetails.work_in_office), proposalDetails.availability && renderResponse(proposalDetails.availability), proposalDetails.us_sponsorship_needed && renderResponse(proposalDetails.us_sponsorship_needed), proposalDetails.agreement && renderResponse(proposalDetails.agreement), proposalDetails.non_compete && renderResponse(proposalDetails.non_compete), showBackgroundCheck && proposalDetails.background_check_type && renderResponse(proposalDetails.background_check_type)), /*#__PURE__*/React.createElement("div", {
        className: "body-section"
      }, proposalDetails.employer ? renderPastRoles(selectedPastRoles) : /*#__PURE__*/React.createElement(AddProposalPastRoles, {
        pastRoles: pastRoles,
        selectedPastRolesIds: selectedPastRolesIds,
        csrfToken: csrfToken,
        proposal: proposal,
        proposalPastRolesUrl: proposalPastRolesUrl,
        isConsultant: proposalDetails.consultant,
        isRep: proposalDetails.rep,
        canEdit: true,
        projectNamn: proposalDetails.project_name
      })), proposalDetails.interviews && /*#__PURE__*/React.createElement("div", {
        className: "body-section"
      }, /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement(Loading, null)
      }, /*#__PURE__*/React.createElement(ProposalInterviews, {
        interviews: proposalDetails.interviews,
        proposalId: proposal.id,
        csrfToken: csrfToken,
        isRep: proposalDetails.rep,
        invitableRoles: invitableRoles,
        possibleInterviewers: initialTeamMembers,
        consultantView: proposalDetails.consultant,
        consultantInterviewPath: consultantInterviewPath,
        canCancel: canCancelInterview,
        canEdit: canEditInterview,
        consultantName: proposalDetails.consultant_name,
        repOrOwner: repOrOwner,
        availableInterviewSlotUrl: availableInterviewSlotUrl
      }))), proposalDetails.employer && /*#__PURE__*/React.createElement("div", {
        className: "body-section"
      }, /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement(Loading, null)
      }, /*#__PURE__*/React.createElement(ProposalQuestion, {
        proposal: proposal,
        csrfToken: csrfToken,
        url: proposalQuestionUrl,
        showModalCallback: function showModalCallback() {
          _this14.setState({
            showAskQuestionModal: false
          });
        },
        modalIsOpen: showAskQuestionModal
      }))));
    }
  }, {
    key: "renderProposalFeeback",
    value: function renderProposalFeeback() {
      var _this15 = this;
      var _this$props15 = this.props,
        csrfToken = _this$props15.csrfToken,
        proposalResourceId = _this$props15.proposalResourceId,
        isSignedIn = _this$props15.isSignedIn,
        signIn = _this$props15.signIn,
        currentUserEmail = _this$props15.currentUserEmail,
        showNewProposalUX = _this$props15.showNewProposalUX;
      var _this$state2 = this.state,
        proposalDetails = _this$state2.proposalDetails,
        showProposalFeedbackModal = _this$state2.showProposalFeedbackModal;
      return /*#__PURE__*/React.createElement(Fragment, null, proposalDetails.can_create_feedback && /*#__PURE__*/React.createElement("div", {
        className: "body-section"
      }, /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement(Loading, null)
      }, /*#__PURE__*/React.createElement(ProposalFeedbacks, {
        isSignedIn: isSignedIn,
        signIn: signIn,
        admin: proposalDetails.rep,
        canEditFeedback: proposalDetails.can_edit_feedback,
        ownerName: proposalDetails.ownerName,
        candidateName: proposalDetails.consultant_name,
        proposalResourceId: proposalResourceId,
        id: proposalDetails.feedback.id,
        consultantFit: proposalDetails.feedback.consultant_fit,
        note: proposalDetails.feedback.note,
        csrfToken: csrfToken,
        email: currentUserEmail,
        feedbacks: proposalDetails.feedbacks,
        location: "proposal",
        buttonStyles: "hearder-teal-green",
        handleShowCoworkerModal: this.handleShowCoworkerModal,
        showModalCallback: function showModalCallback() {
          _this15.setState({
            showProposalFeedbackModal: false
          });
        },
        modalIsOpen: showProposalFeedbackModal,
        handleProposalAfterSubmit: function handleProposalAfterSubmit(data) {
          return _this15.handleAfterSubmit(data);
        },
        showNewProposalUX: showNewProposalUX
      }))));
    }
  }, {
    key: "renderTabContent",
    value: function renderTabContent() {
      var _this$props16 = this.props,
        csrfToken = _this$props16.csrfToken,
        proposalResourceId = _this$props16.proposalResourceId,
        proposalViews = _this$props16.proposalViews,
        showAdvisorRemark = _this$props16.showAdvisorRemark,
        repOrOwner = _this$props16.repOrOwner;
      var _this$state3 = this.state,
        proposalDetails = _this$state3.proposalDetails,
        document = _this$state3.document,
        originalDocument = _this$state3.originalDocument,
        selectedTab = _this$state3.selectedTab;
      switch (selectedTab) {
        case 'Resume':
          return /*#__PURE__*/React.createElement("div", {
            className: "resume-details"
          }, /*#__PURE__*/React.createElement(Suspense, {
            fallback: /*#__PURE__*/React.createElement(Loading, null)
          }, /*#__PURE__*/React.createElement(Resume, {
            document: document,
            originalDocument: originalDocument,
            showHeader: false
          })));
        case 'Interview Questions':
          return /*#__PURE__*/React.createElement("div", {
            className: "proposal-details"
          }, this.renderleftBodyContent(), /*#__PURE__*/React.createElement("div", {
            className: "right-body-content"
          }, this.renderProposalFeeback(), /*#__PURE__*/React.createElement(Suspense, {
            fallback: /*#__PURE__*/React.createElement(Loading, null)
          }, /*#__PURE__*/React.createElement(InterviewQuestions, {
            consultantName: proposalDetails.consultant_name,
            proposalResourceId: proposalResourceId,
            interviewQuestionsUrl: proposalDetails.interview_questions_url,
            isConsultant: proposalDetails.consultant,
            csrfToken: csrfToken
          }))));
        case 'PDF Preview':
          // We show the server-rendered inline preview outside React; nothing to render here
          return /*#__PURE__*/React.createElement("div", {
            className: "proposal-details"
          });
        case 'Messages':
          return /*#__PURE__*/React.createElement("div", {
            className: "proposal-details"
          }, this.renderleftBodyContent(), /*#__PURE__*/React.createElement("div", {
            className: "right-body-content"
          }, this.renderProposalFeeback(), /*#__PURE__*/React.createElement(Suspense, {
            fallback: /*#__PURE__*/React.createElement(Loading, null)
          }, /*#__PURE__*/React.createElement(ProposalMessages, {
            indexUrl: proposalDetails.messages_index_url,
            createUrl: proposalDetails.messages_create_url,
            csrfToken: csrfToken,
            isRep: proposalDetails.rep,
            isEmployer: proposalDetails.employer,
            isConsultant: proposalDetails.consultant,
            onAskQuestion: this.handleShowAskQuestion
          })), /*#__PURE__*/React.createElement(ProposalResourceScript, {
            resourceId: proposalResourceId
          })));
        default:
          return /*#__PURE__*/React.createElement("div", {
            className: "proposal-details"
          }, this.renderleftBodyContent(), /*#__PURE__*/React.createElement("div", {
            className: "right-body-content"
          }, proposalDetails.missing_required_response && /*#__PURE__*/React.createElement("div", {
            className: "body-section"
          }, /*#__PURE__*/React.createElement("div", {
            className: "missing-requirements"
          }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, proposalDetails.missing_required_response.header)), /*#__PURE__*/React.createElement("span", null, "Remember that the employer will choose up to 3 consultants to interview based on their proposals."), Object.entries(proposalDetails.missing_required_response.requirements).map(function (_ref5) {
            var _ref6 = _slicedToArray(_ref5, 2),
              key = _ref6[0],
              value = _ref6[1];
            if (key.match(/_errors_count/) && value > 0) {
              return /*#__PURE__*/React.createElement("span", {
                className: "body-text-3 my-3",
                key: key
              }, "".concat(value, " missing responses in ").concat(key.replace(/_errors_count/, '').replace(/_/g, ' ').toLowerCase(), "!"));
            }
            return null;
          }))), proposalViews && /*#__PURE__*/React.createElement("div", {
            className: "body-section"
          }, /*#__PURE__*/React.createElement(UserViewsTable, {
            userViews: proposalViews,
            userHeader: "Employer"
          })), this.renderProposalFeeback(), repOrOwner && /*#__PURE__*/React.createElement(Suspense, {
            fallback: /*#__PURE__*/React.createElement(Loading, null)
          }, /*#__PURE__*/React.createElement(ProjectFitSummary, {
            proposalResourceId: proposalResourceId,
            csrfToken: csrfToken
          })), showAdvisorRemark && /*#__PURE__*/React.createElement("div", {
            className: "body-section"
          }, renderAdvisorRemark(proposalDetails.advisor_remark)), (proposalDetails.edit_requested || proposalDetails.rejection_reason || proposalDetails.withdraw_reason) && /*#__PURE__*/React.createElement("div", {
            className: "body-section"
          }, /*#__PURE__*/React.createElement("div", {
            className: "alert alert-warning"
          }, proposalDetails.rejection_reason && /*#__PURE__*/React.createElement(Fragment, null, proposalDetails.rejection_reason.user && /*#__PURE__*/React.createElement("span", {
            className: "g-column rejection-reason mb-3"
          }, "User: ".concat(proposalDetails.rejection_reason.user)), /*#__PURE__*/React.createElement("span", {
            className: "g-column rejection-reason mb-2"
          }, proposalDetails.rejection_reason.decline_reason), /*#__PURE__*/React.createElement("span", {
            className: "g-column rejection-reason mb-2"
          }, proposalDetails.rejection_reason.text_description)), proposalDetails.withdraw_reason && /*#__PURE__*/React.createElement(Fragment, null, proposalDetails.withdraw_reason.user && /*#__PURE__*/React.createElement("span", {
            className: "g-column rejection-reason mb-2"
          }, "User: ".concat(proposalDetails.withdraw_reason.user)), /*#__PURE__*/React.createElement("span", {
            className: "g-column rejection-reason mb-2"
          }, proposalDetails.withdraw_reason.withdraw_reason), /*#__PURE__*/React.createElement("span", {
            className: "g-column rejection-reason mb-2"
          }, proposalDetails.withdraw_reason.text_description)), proposalDetails.edit_requested && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("blockquote", {
            className: "mt-3 secondary-body-text"
          }, proposalDetails.edit_requested.comment), /*#__PURE__*/React.createElement("span", null, "Edits requested on ".concat(proposalDetails.edit_requested.created_at))))), /*#__PURE__*/React.createElement("div", {
            className: "body-section"
          }, proposalDetails.about_consultant && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", {
            className: "hearder-teal-green"
          }, "About"), /*#__PURE__*/React.createElement("span", null, proposalDetails.about_consultant), /*#__PURE__*/React.createElement("hr", null)), proposalDetails.screening_question.questions.length ? /*#__PURE__*/React.createElement("div", {
            className: "expertise-tags one"
          }, /*#__PURE__*/React.createElement("h2", {
            className: "hearder-teal-green"
          }, proposalDetails.screening_question.header), proposalDetails.screening_question.questions.map(function (q) {
            return /*#__PURE__*/React.createElement(ProposalResponse, {
              checked: q.checked,
              description: q.description,
              notes: q.notes,
              extraSpanClasses: q.extraSpanClasses
            });
          }), /*#__PURE__*/React.createElement("hr", null)) : null, (proposalDetails.therapeutic_areas || proposalDetails.indications) && /*#__PURE__*/React.createElement("div", {
            className: "expertise-tags two"
          }, /*#__PURE__*/React.createElement("div", {
            className: "row"
          }, proposalDetails.therapeutic_areas && renderExpertiseTag('Therapeutic Areas', proposalDetails.therapeutic_areas, 'col-md-6'), proposalDetails.indications && renderExpertiseTag('Indications', proposalDetails.indications, 'col-md-6')), /*#__PURE__*/React.createElement("hr", null)), (proposalDetails.therapies || proposalDetails.regulatory_pathways) && /*#__PURE__*/React.createElement("div", {
            className: "expertise-tags three"
          }, /*#__PURE__*/React.createElement("div", {
            className: "row"
          }, proposalDetails.therapies && renderExpertiseTag('Product Technologies', proposalDetails.therapies, 'col-md-6'), proposalDetails.regulatory_pathways && renderExpertiseTag('Regulatory Pathways', proposalDetails.regulatory_pathways, 'col-md-6')), /*#__PURE__*/React.createElement("hr", null)), (proposalDetails.education_levels || proposalDetails.accreditations) && /*#__PURE__*/React.createElement("div", {
            className: "expertise-tags four"
          }, /*#__PURE__*/React.createElement("div", {
            className: "row"
          }, proposalDetails.education_levels && renderExpertiseTag('Education Requirements', proposalDetails.education_levels, 'col-md-6'), proposalDetails.accreditations && renderExpertiseTag('Certifications', proposalDetails.accreditations, 'col-md-6')), /*#__PURE__*/React.createElement("hr", null)), proposalDetails.languages && /*#__PURE__*/React.createElement("div", {
            className: "expertise-tags"
          }, /*#__PURE__*/React.createElement("div", {
            className: "row"
          }, proposalDetails.languages && renderExpertiseTag('Languages', proposalDetails.languages)), /*#__PURE__*/React.createElement("hr", null)), proposalDetails.consultant_question && /*#__PURE__*/React.createElement("div", {
            className: "expertise-tags"
          }, /*#__PURE__*/React.createElement("div", {
            className: "row"
          }, /*#__PURE__*/React.createElement("div", {
            className: "col-xs-12 expertise-tag"
          }, /*#__PURE__*/React.createElement("h2", {
            className: "hearder-teal-green"
          }, "Questions from the Consultant"), /*#__PURE__*/React.createElement(ProposalResponse, {
            notes: proposalDetails.consultant_question
          })))))));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this16 = this;
      var _this$props17 = this.props,
        consultantDetails = _this$props17.consultantDetails,
        proposalResourceId = _this$props17.proposalResourceId,
        csrfToken = _this$props17.csrfToken,
        initialTeamMembers = _this$props17.initialTeamMembers,
        invitableRoles = _this$props17.invitableRoles,
        editableRoles = _this$props17.editableRoles,
        basePermissionsUrl = _this$props17.basePermissionsUrl,
        copyLink = _this$props17.copyLink,
        buttonEnabled = _this$props17.buttonEnabled,
        showNewProposalUX = _this$props17.showNewProposalUX;
      var _this$state4 = this.state,
        isSticky = _this$state4.isSticky,
        headerTabs = _this$state4.headerTabs,
        proposalDetails = _this$state4.proposalDetails,
        showAddCoworkerModal = _this$state4.showAddCoworkerModal,
        showWaitlistModal = _this$state4.showWaitlistModal;
      return /*#__PURE__*/React.createElement("div", {
        className: "new-proposal-ux"
      }, /*#__PURE__*/React.createElement("div", {
        className: "sticky-proposal-header ".concat(isSticky && 'show-sticky')
      }, /*#__PURE__*/React.createElement("div", {
        className: "sticky-proposal-header__nav"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-info"
      }, this.renderNameAndStatus()), this.renderHeaderActions(true))), /*#__PURE__*/React.createElement("div", {
        className: "proposal-header__container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "proposal-header__nav"
      }, /*#__PURE__*/React.createElement("div", {
        className: "proposal-header__top"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-info"
      }, this.renderNameAndStatus()), /*#__PURE__*/React.createElement("div", {
        className: "proposal-header__details"
      }, consultantDetails.rating_avg && /*#__PURE__*/React.createElement("span", {
        className: "proposal-header__rating"
      }, /*#__PURE__*/React.createElement(StarRatings, {
        rating: consultantDetails.rating_avg,
        starRatedColor: "#EDA318",
        starHoverColor: "#EDA318",
        starDimension: "20px",
        starSpacing: "1px",
        numberOfStars: 5,
        name: "rating_avg"
      }), /*#__PURE__*/React.createElement("span", {
        className: "ms-2"
      }, consultantDetails.rating_avg)), (consultantDetails.city || consultantDetails.city_location) && /*#__PURE__*/React.createElement("span", {
        className: "proposal-header__location"
      }, /*#__PURE__*/React.createElement("span", {
        className: ""
      }, imgTag(userMapIcon, 'location-icon')), consultantDetails.city || consultantDetails.city_location), consultantDetails.years_of_experience && /*#__PURE__*/React.createElement("span", {
        className: "proposal-header__experience"
      }, /*#__PURE__*/React.createElement("span", {
        className: ""
      }, imgTag(experienceIcon, 'experience-icon')), consultantDetails.years_of_experience), proposalDetails.rep && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("a", {
        href: proposalDetails.consultant_profile_link,
        className: "proposal-header__link",
        target: "_blank",
        rel: "noreferrer"
      }, /*#__PURE__*/React.createElement("span", {
        className: ""
      }, imgTag(profileIcon, 'profile-icon')), "View Profile"), /*#__PURE__*/React.createElement("a", {
        href: consultantDetails.clorify_link,
        className: "proposal-header__link",
        target: "_blank",
        rel: "noreferrer"
      }, /*#__PURE__*/React.createElement("span", {
        className: ""
      }, imgTag(cloraIcon, 'clora-icon')), "View Clorify")))), this.renderHeaderActions(), /*#__PURE__*/React.createElement("div", {
        className: "proposal-header__tabs"
      }, headerTabs.map(function (tab, i) {
        return _this16.renderTab(tab, i);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "proposal-header__footer-note"
      }, /*#__PURE__*/React.createElement("div", {
        className: "footer-note__container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "left-content"
      }, proposalDetails.submitted_info, /*#__PURE__*/React.createElement("span", {
        className: "ms-2"
      }, imgTag(clockIcon, 'clora-icon'))), /*#__PURE__*/React.createElement("div", {
        className: "right-content"
      }, /*#__PURE__*/React.createElement("span", null, "Project:", /*#__PURE__*/React.createElement("a", {
        className: "project_link",
        href: "".concat(proposalDetails.project_link, "?tab=proposals")
      }, proposalDetails.project_name)), (proposalDetails.rep || proposalDetails.employer) && /*#__PURE__*/React.createElement("span", {
        className: "coworker-modal"
      }, /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement(Loading, null)
      }, /*#__PURE__*/React.createElement(AddCoworkersModal, {
        csrfToken: csrfToken,
        initialTeamMembers: initialTeamMembers,
        invitableRoles: invitableRoles,
        editableRoles: editableRoles,
        basePermissionsUrl: basePermissionsUrl,
        proposalResourceId: proposalResourceId,
        copyLink: copyLink,
        buttonEnabled: buttonEnabled,
        consultantName: proposalDetails.consultant_name,
        location: "proposal",
        showModalCallback: function showModalCallback() {
          _this16.setState({
            showAddCoworkerModal: false
          });
        },
        modalIsOpen: showAddCoworkerModal,
        showNewProposalUX: showNewProposalUX
      })), /*#__PURE__*/React.createElement("button", {
        className: "btn btn--text-blue",
        onClick: this.handleShowCoworkerModal
      }, "Add")))))), /*#__PURE__*/React.createElement("div", {
        className: "proposal-body__container consultant-overview"
      }, this.renderTabContent()), /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement(Loading, null)
      }, /*#__PURE__*/React.createElement(WaitlistedNotification, {
        consultantName: proposalDetails.consultant_name,
        showModal: showWaitlistModal,
        handleShowCoworkerModal: this.handleShowCoworkerModal,
        handleShowQuestion: this.handleShowAskQuestion,
        isEmployer: proposalDetails.employer,
        handleCloseModal: this.handleToggleWaitlistModal
      })));
    }
  }]);
}(Component);
ProposalShow.propTypes = {
  consultantDetails: PropTypes.shape({}),
  proposalDetails: PropTypes.shape({}),
  csrfToken: PropTypes.string.isRequired,
  proposalResourceId: PropTypes.string.isRequired,
  initialTeamMembers: PropTypes.shape({
    team_members: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  invitableRoles: PropTypes.arrayOf(PropTypes.string),
  editableRoles: PropTypes.arrayOf(PropTypes.string),
  basePermissionsUrl: PropTypes.string.isRequired,
  copyLink: PropTypes.string.isRequired,
  buttonEnabled: PropTypes.bool,
  cloraCreaeRroposalCommentsUrl: PropTypes.string.isRequired,
  createInterviewUrl: PropTypes.string.isRequired,
  acceptProposalUrl: PropTypes.string.isRequired,
  editProposalUrl: PropTypes.string.isRequired,
  proposal: PropTypes.shape({}).isRequired,
  proposalPastRolesUrl: PropTypes.string.isRequired,
  pastRoles: PropTypes.arrayOf(PropTypes.shape({})),
  selectedPastRolesIds: PropTypes.arrayOf([]),
  selectedPastRoles: PropTypes.arrayOf(PropTypes.shape({})),
  proposalQuestionUrl: PropTypes.string.isRequired,
  completionPercentage: PropTypes.number,
  userPath: PropTypes.string.isRequired,
  consultantInterviewPath: PropTypes.string.isRequired,
  canCancelInterview: PropTypes.bool,
  canEditInterview: PropTypes.bool,
  proposalViews: PropTypes.arrayOf(PropTypes.shape({})),
  isSignedIn: PropTypes.bool,
  signIn: PropTypes.bool,
  currentUserEmail: PropTypes.string.isRequired,
  showAdvisorRemark: PropTypes.bool,
  animation: PropTypes.bool,
  updateUserSettingsUrl: PropTypes.string.isRequired,
  disabledSubmitProposal: PropTypes.bool,
  referralProps: PropTypes.shape({}),
  generateShareableLink: PropTypes.string.isRequired,
  showShareAction: PropTypes.bool,
  sourceOptions: PropTypes.arrayOf(PropTypes.shape({})),
  recipientOptions: PropTypes.arrayOf(PropTypes.shape({})),
  showNewProposalUX: PropTypes.bool,
  visibleFeedbackOptions: PropTypes.arrayOf(PropTypes.shape({})),
  hiddenFeedbackOptions: PropTypes.arrayOf(PropTypes.shape({})),
  consultantFeedbackOptions: PropTypes.arrayOf(PropTypes.shape({})),
  projectsOptions: PropTypes.arrayOf(PropTypes.shape({})),
  reasonOptions: PropTypes.arrayOf(PropTypes.shape({})),
  withdrawUrl: PropTypes.string.isRequired,
  projectResourceId: PropTypes.string.isRequired,
  repOrOwner: PropTypes.bool,
  showBackgroundCheck: PropTypes.bool,
  submitToOpenMarketplace: PropTypes.bool,
  availableInterviewSlotUrl: PropTypes.string.isRequired
};
ProposalShow.defaultProps = {
  consultantDetails: {},
  proposalDetails: {
    status: 'drafting'
  },
  reasonOptions: [],
  buttonEnabled: false,
  canCancelInterview: false,
  canEditInterview: false,
  proposalViews: [],
  isSignedIn: false,
  signIn: false,
  showAdvisorRemark: '',
  animation: false,
  submitToOpenMarketplace: false,
  disabledSubmitProposal: false,
  referralProps: {},
  showNewProposalUX: false,
  repOrOwner: false,
  showBackgroundCheck: false
};
export default ProposalShow;